module.exports = __webpack_public_path__ + "static/media/el-ateneo.42dfa893.md";